import { now, createDate, formatAsDate } from '../config/dayjsConfig'

export default {
  0: (state: any) => {
    return {
      ...state,
      context: {
        ...state.context,
        filters: {
          ...state.context.filters,
          cumulativeDataTypes: []
        }
      }
    }
  },
  1: (state: any) => {
    return {
      ...state,
      context: {
        ...state.context,
        filters: {
          ...state.context.filters,
          periodGroups: []
        }
      }
    }
  },
  2: (state: any) => {
    return {
      ...state,
      context: {
        ...state.context,
        reports: {
          ...state.context.reports,
          financialStatement: {
            incomeStatement: [],
            assets: [],
            liabilities: []
          }
        }
      }
    }
  },
  3: (state: any) => {
    return {
      ...state,
      pages: {
        ...state.pages,
        accountantDashboard: {
          ...state.pages.accountantDashboard,
          periodGroups: [
            {
              id: now().year(),
              startDate: formatAsDate(createDate(now().year(), 1, 1)) ?? '',
              endDate: formatAsDate(createDate(now().year(), 12, 1)) ?? ''
            }
          ]
        }
      }
    }
  },
  4: (state: any) => {
    return {
      ...state,
      pages: {
        ...state.pages,
        scenarioDashboard: {
          selectedScenarios: [],
          selectedKeyfigures: [],
          selectedInternalKeyfigures: [],
          keyfigureStatements: {},
          internalKeyfigureStatements: {},
          groupId: undefined
        }
      }
    }
  },
  5: (state: any) => {
    return {
      ...state,
      pages: {
        // eslint-disable-next-line react/destructuring-assignment
        ...state.pages,
        investmentsPage: {
          date: null,
          existingInvestments: null
        }
      }
    }
  },
  6: (state: any) => {
    return {
      ...state,
      pages: {
        // eslint-disable-next-line react/destructuring-assignment
        ...state.pages,
        accountantDashboard: {
          activeDashboard: undefined,
          dashboards: [],
          formulas: {},
          globalKeyfigureStatements: {}
        }
      }
    }
  },
  7: (state: any) => {
    return {
      ...state,
      context: {
        ...state.context,
        reports: {
          ...state.context.reports,
          sales: {
            ...state.context.reports.sales,
            customerGroups: []
          }
        }
      }
    }
  },
  8: (state: any) => {
    return {
      ...state,
      context: {
        ...state.context,
        filters: {
          ...state.context.filters,
          dimensionsQuery: undefined
        }
      }
    }
  },
  9: (state: any) => {
    return {
      ...state,
      context: {
        ...state.context,
        filters: {
          ...state.context.filters,
          dimensionsQuery: undefined
        }
      }
    }
  }
}
